module.exports = __webpack_public_path__ + "static/media/pattern3.8b978129.jpg";